import { useMutation, useQueryClient } from 'react-query'

import { restoreCommentsFromHistory } from '../api/restoreCommentFromHistory'

interface IUseRestoreCommentsFromHistory {
  externalId: string
  externalEntityInfo: string
}

interface IRequest {
  commentIds: string[]
}

export function useRestoreCommentsFromHistory({
  externalId,
  externalEntityInfo,
}: IUseRestoreCommentsFromHistory) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ commentIds }: IRequest) =>
      restoreCommentsFromHistory({
        externalId,
        externalEntityInfo,
        commentIds,
      }),
    onSuccess: () =>
      queryClient.invalidateQueries([
        'comments-history',
        externalId,
        externalEntityInfo,
      ]),
  })
}
